<template>
  <div>

    <el-table class="table" size="mini" :data="tableData" :height="hh" border>
      <el-table-column prop="elderlyName" width="100" label="姓名"></el-table-column>
      <el-table-column prop="hospital" width="100" label="就诊医院"></el-table-column>
      <el-table-column prop="seeDoctorTime" :formatter="timefilter" label="就诊时间"  min-width="100"></el-table-column>
<!--      <el-table-column prop="entourage" label="陪同人员"  width="100"></el-table-column>-->
      <el-table-column prop="physicalExamination" width="150" label="就诊内容"></el-table-column>
      <el-table-column prop="diagnosisResults" label="就诊结果"  width="200"></el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
      <div style="float: left;">
        <el-pagination small
                       background
                       layout="prev, pager, next"
                       :total="totalItems"
                       :page-size="pageSize"
                       :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
      </div>
      <div style="float: right">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
      </div>
      <div style="clear: both;"></div>
    </div>

    <SeeDoctorRecordsAdd ref="mySeeDoctorRecordsAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
                           v-on:resultSuccess="resultSuccess"></SeeDoctorRecordsAdd>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import SeeDoctorRecordsAdd from "./SeeDoctorRecordsAdd";

export default {
  name: "ExaminationRecords",
  data(){
    return{
      showModalAdd: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      userCode: "",
      elderlyCode: "",
      elderlyName:'',


      hh:this.$store.state.tableHeight-170,

    }
  },
  created(){

  },
  components:{
    SeeDoctorRecordsAdd
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.hh = val - 170;
    },
    disabled(val){
      //this.th = this.$store.state.tableHeight-(val?50:100);
    }
  },
  methods:{
    init(userCode,elderlyCode,elderlyName) {

      this.elderlyCode=elderlyCode;
      this.userCode=userCode;
      this.elderlyName = elderlyName;
      this.getList();
    },

    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.mySeeDoctorRecordsAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    resultSuccess(){
      this.currentPage = 1;
      this.getList();
    },

    getList() {
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ESeeDoctorRecord/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode: this.elderlyCode,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
            console.log(error);
          });
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,11)
    },

    handleDelete(index,row){

      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "ESeeDoctorRecord/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            eseeDoctorRecordCode:row.eseeDoctorRecordCode,

          }
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {

            this.getList();

          } else if (response.data.error == 1) {
            this.$message({type: 'info', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(e => e)

    },




  },

}
</script>

<style scoped>

</style>
